/**
 * Represents an error encountered whilst processing a move request.
 * Contains the type encountered and the actual caught error
 */
export interface IBaseMoveError<ET, E> {
    errorType: ET
    error: E
}

/**
 * Error thrown if an exception takes place whilst processing
 * a move request.
 */
abstract class BaseMoveError<ET, E> extends Error {
    errors: IBaseMoveError<ET, E>[]

    constructor(errors: IBaseMoveError<ET, E>[]) {
        super()
        this.errors = errors
    }
}

export { BaseMoveError }
